import { workflowsOutcomes } from "./workflows-outcomes";

/** Workflows phase 4 (M26): canvas, mga bersyon, reusable workflow, paghihintay ng webhook, layunin at library ng template. Isinasama sa `engage.workflows`. */
export const workflowsP4 = {
  triggers: { reusable: "Reusable na workflow" },
  triggerHints: { reusable: "Mga hakbang na maaaring patakbuhin ng ibang workflow (o ng staff sa Inbox)." },
  conditionGroups: { webhook: "Webhook" },
  columns: { engaged: "Nakipag-ugnayan", goal: "Layunin" },
  goalTitle: "Layunin: {{event}}",
  tabs: { build: "Builder", overview: "Buod", paths: "Pagsusuri ng path", runs: "Mga run", versions: "Mga bersyon", translations: "Mga salin" },
  steps: { run_workflow: "Magpatakbo ng workflow", wait_for_webhook: "Maghintay ng webhook" },
  summaries: {
    run_workflow: "Pinapatakbo ang {{workflow}}",
    wait_for_webhook_one: "Maghintay nang hanggang {{count}} oras sa inyong sistema",
    wait_for_webhook_other: "Maghintay nang hanggang {{count}} oras sa inyong sistema",
  },
  exits: { received: "Natanggap", timedOut: "Naubusan ng oras" },
  incomplete: { workflow: "Piliin ang workflow na patatakbuhin" },
  fields: {
    reusablePlan: "Kailangan ng planong {{plan}} o mas mataas para magpatakbo ng ibang workflow.",
    reusableWorkflow: "Workflow na patatakbuhin",
    reusableHint: "Mga reusable workflow lang na tumatakbo sa likod ang maaaring patakbuhin. Tatakbo ito sa usapang ito, saka magpapatuloy ang workflow na ito. Hanggang {{depth}} antas ang lalim; hindi maaaring patakbuhin ng workflow ang sarili nito, diretso man o sa pamamagitan ng iba.",
    reusableNotLive: "{{name}} (hindi pa live)",
    reusableNotLiveWarning: "Hindi live ang {{name}}. I-publish muna ito bago i-publish ang workflow na ito.",
    reusableNone: "Wala pang reusable na workflow. Gumawa ng isa gamit ang trigger na “Reusable na workflow”.",
    reusableOpenList: "Buksan ang Workflows",
    reusableOpen: "Buksan ang {{name}}",
    hookTimeout: "Maghintay nang hanggang (oras)",
    hookTimeoutHint: "Kung hindi pa tumatawag ang inyong sistema pagdating noon, dadaan ang run sa labasang “naubusan ng oras”. Hanggang {{max}} oras (7 araw).",
    hookExample: "Halimbawa ng ipinapadala ng inyong sistema",
    hookExampleHint: "Isang patag na JSON object (hanggang {{keys}} field). Nagiging variable na nagsisimula sa {{prefix}} ang bawat field para sa mga hakbang pagkatapos nito. Para lang sa builder ang halimbawa.",
    hookExamplePlaceholder: "{\n  \"order_id\": \"A-1042\",\n  \"paid\": true\n}",
    hookExampleProblems: {
      json: "Hindi pa ito wastong JSON.",
      object: "Gumamit ng JSON object tulad ng { \"order_id\": \"A-1042\" }.",
      count: "Hanggang {{max}} field lang.",
      key: "Hindi wastong pangalan ng field ang “{{key}}”. Magsimula sa titik; gumamit ng titik, numero at underscore.",
      duplicate: "Dalawang beses lumabas ang “{{key}}” (hindi nakikilala ang laki ng titik sa pangalan ng field).",
      value: "Dapat teksto (hanggang {{chars}} karakter), numero, true, false o null ang “{{key}}”.",
    },
    hookVariables: "Mga variable mula sa tawag",
    hookReceivedGoTo: "Kapag dumating ang tawag, pumunta sa",
    hookReceivedHint: "Kung walang pinili, magpapatuloy ang run sa susunod na hakbang.",
    hookTimeoutGoTo: "Kung maubusan ng oras, pumunta sa",
    hookTimeoutGoToHint: "Kung walang pinili, tatapusin ng pag-ubos ng oras ang run.",
    nextStep: "Ang susunod na hakbang",
  },
  hook: {
    specFailed: "Hindi namin ma-load kung paano tatawagan ang URL.",
    howTitle: "Paano ito tatawagan ng inyong sistema",
    howBody: "Pagdating ng run sa hakbang na ito, may sarili itong lihim na URL. Magpapadala ang inyong sistema ng nilagdaang JSON request doon at magpapatuloy ang run.",
    urlPattern: "URL",
    copyPattern: "Kopyahin ang pattern ng URL",
    copied: "Nakopya",
    stepSecret: "Buksan ang run (tab na Mga run) para makita ang URL at secret nito habang naghihintay.",
    stepSign: "Lagdaan ang request: ilagay ang timestamp at signature sa header na {{header}}.",
    stepSend: "Magpadala ng JSON na hanggang {{limit}} KB: patag na mga field lang, hanggang {{keys}} field, {{chars}} karakter bawat value.",
    signatureLabel: "Anyo ng header ng signature",
    tolerance: "Tinatanggihan ang mga request na mas luma sa {{minutes}} minuto. Magpadala ng {{header}} para ligtas ang pag-ulit.",
    runTitle: "Naghihintay sa inyong sistema",
    statuses: { waiting: "Naghihintay", received: "Natanggap", timed_out: "Naubusan ng oras", cancelled: "Kinansela" },
    receivedAt: "Natanggap {{when}}",
    timeoutAt: "Mauubusan ng oras {{when}}",
    runUrl: "URL ng run na ito",
    copyUrl: "Kopyahin ang URL",
    runSecret: "Secret ng run na ito",
    showSecret: "Ipakita ang secret",
    hideSecret: "Itago ang secret",
    copySecret: "Kopyahin ang secret",
    runSecretHint: "Itago ang secret sa inyong server. Sinumang may hawak nito ay maaaring magpatuloy ng run na ito.",
    closed: "Tapos na ang paghihintay, kaya hindi na ipinapakita ang URL at secret.",
    managersOnly: "Ang mga miyembrong may karapatang mamahala ng workflow lang ang nakakakita ng URL at secret.",
  },
  goal: {
    label: "Layunin (opsyonal)",
    hint: "Ang tinuturing na tagumpay ng workflow na ito. Lalabas ito bilang Goal % sa listahan at sa Buod.",
    none: "Walang layunin",
    events: {
      booking_confirmed: "Nakumpirma ang booking",
      lead_created: "Nakuha ang lead",
      conversation_resolved: "Naresolba ang usapan",
      conversation_rated: "Nai-rate ang usapan",
    },
    within: "Binibilang kapag nangyari sa loob ng",
    withinHint: "Mula sa pagsisimula ng run. Mula 1 oras hanggang {{max}} oras (30 araw).",
    hours: "oras",
    window_hours_one: "{{count}} oras",
    window_hours_other: "{{count}} oras",
    window_days_one: "{{count}} araw",
    window_days_other: "{{count}} araw",
  },
  canvas: {
    view: "Tanaw",
    list: "Listahan",
    canvas: "Canvas",
    title: "Canvas",
    toolbar: "Mga kontrol ng canvas",
    region: "Canvas ng workflow",
    hint: "Canvas ng parehong workflow. Gamitin ang Listahan kung keyboard o screen reader ang gamit: iisang mga hakbang ang ine-edit ng dalawa. May tuldok ang bawat labasan: i-drag ito sa isang path para ikonekta, o pindutin ang Enter dito para sa menu. Sa canvas, i-drag ang background para umusog, gamitin ang mga arrow key, at mag-zoom gamit ang + at -, ang mga button, o Ctrl + scroll.",
    zoomIn: "I-zoom in",
    zoomOut: "I-zoom out",
    resetZoom: "I-reset ang zoom",
    tidyUp: "Ayusin",
    agents_one: "{{count}} agent",
    agents_other: "{{count}} agent",
    triggerSheetHint: "Ang nagpapasimula ng workflow na ito, at kung para kanino ito.",
  },
  versions: {
    title: "Mga bersyon",
    subtitle: "Nagse-save ng bersyon ang bawat publish. Ang pag-roll back ay gagawa ng bagong draft mula rito: tatapusin ng mga tumatakbong run ang sarili nilang bersyon.",
    draft: "Draft",
    live: "Live",
    versionLive: "Bersyon {{number}} (live)",
    versionName: "Bersyon {{number}}",
    versionShort: "v{{number}}",
    rowMeta: "{{name}} · {{when}} · {{runs}} run",
    draftMeta: "{{name}} · {{when}}",
    view: "Tingnan",
    viewVersion: "Tingnan ang bersyon {{number}}",
    compareLive: "Ihambing sa live",
    compareVersion: "Ihambing ang bersyon {{number}} sa live",
    compareWithLive: "Ihambing sa live",
    rollback: "I-roll back",
    rollbackVersion: "I-roll back sa bersyon {{number}}",
    rolledBack: "Draft na ang bersyon {{number}}. I-publish ito para maging live.",
    loadFailed: "Hindi namin ma-load ang mga bersyon.",
    hidden_one: "Ipinapakita ng plano ninyo ang huling {{limit}} bersyon. Nakatago ang {{count}} mas lumang bersyon.",
    hidden_other: "Ipinapakita ng plano ninyo ang huling {{limit}} bersyon. Nakatago ang {{count}} mas lumang bersyon.",
    upgrade: "Tingnan ang mga plano",
    emptyTitle: "Wala pang bersyon",
    emptyBody: "I-publish ang workflow para ma-save ang bersyon 1.",
    viewTitle: "Bersyon {{number}}",
    viewMeta: "Na-publish {{when}} ni {{name}}",
    readOnly: "Na-publish na bersyon ito. Maaari lang tingnan, hindi baguhin.",
    readOnlyBadge: "Pagbasa lang",
    viewFailed: "Hindi namin ma-load ang bersyong ito.",
    forceTitle: "Palitan ang draft ng bersyon {{number}}?",
    forceBody: "May mga pagbabago ang draft ninyo na hindi pa na-publish. Papalitan ng pag-roll back ang mga iyon ng bersyon {{number}}.",
    forceBodyUnsaved: "May mga pagbabago kayo sa builder na hindi pa na-publish. Papalitan ng pag-roll back ang mga iyon ng bersyon {{number}}.",
    forceConfirm: "Palitan ang draft",
    compareTitle: "Paghambingin ang mga bersyon",
    compareHint: "Namarkahan sa bawat panig ang mga hakbang na nadagdag, natanggal, nabago o nailipat.",
    compareBase: "Mula sa",
    compareTarget: "Hanggang sa",
    unsavedNote: "Wala sa paghahambing na ito ang mga pagbabagong hindi pa na-save. I-save muna ang draft para maisama ang mga ito.",
    compareFailed: "Hindi namin maihambing ang mga bersyong ito.",
    summary: "Ang nagbago",
    counts: {
      added_one: "{{count}} hakbang ang nadagdag",
      added_other: "{{count}} hakbang ang nadagdag",
      removed_one: "{{count}} hakbang ang natanggal",
      removed_other: "{{count}} hakbang ang natanggal",
      changed_one: "{{count}} hakbang ang nabago",
      changed_other: "{{count}} hakbang ang nabago",
      moved_one: "{{count}} hakbang ang nailipat",
      moved_other: "{{count}} hakbang ang nailipat",
    },
    settingsChanged: "Nagbago ang mga setting",
    translationsChanged: "Nagbago ang mga salin",
    identicalTitle: "Magkapareho ang mga ito",
    identicalBody: "Walang pagkakaiba sa hakbang, setting o salin.",
    status: { added: "Nadagdag", removed: "Natanggal", changed: "Nabago", moved: "Nailipat", unchanged: "Pareho" },
    changedFields: "Nabago: {{fields}}",
    noSteps: "Walang hakbang",
  },
  analysis: {
    title: "Pagsusuri ng path",
    subtitle: "Kung saan nagpapatuloy at kung saan humihinto ang mga bisita, hakbang-hakbang.",
    version: "Bersyon",
    allVersions: "Lahat ng bersyon",
    versionLive: "v{{number}} (live)",
    versionName: "v{{number}}",
    period: "Panahon",
    days_one: "Nakaraang {{count}} araw",
    days_other: "Nakaraang {{count}} araw",
    loadFailed: "Hindi namin ma-load ang pagsusuri ng path.",
    emptyTitle: "Walang run na susuriin",
    emptyBody: "Kapag dumaan na ang mga bisita sa bersyong ito, makikita ninyo kung hanggang saan umaabot ang bawat hakbang.",
    sent_one: "{{formatted}} run ang nagsimula",
    sent_other: "{{formatted}} run ang nagsimula",
    columns: { step: "Path · hakbang", reached: "Umabot", continued: "Nagpatuloy", dropped: "Huminto", waiting: "Naghihintay", failed: "Pumalya", filled: "Nakuhang datos" },
    answersTitle: "Aling button ang pinipili ng mga bisita",
    answerCount: "{{count}} · {{share}}",
    continuedOf: "Nagpatuloy mula sa {{step}}",
    note: "Maaaring mabilang ang isang bisita sa higit sa isang path. Hindi kasama ang mga preview run.",
    ...workflowsOutcomes.analysis,
  },
  translations: {
    title: "Mga salin",
    subtitle: "Makikita ng mga bisita ang bersyon sa kanilang wika. Hindi kailanman isinasalin ang mga nakolektang sagot.",
    primary: "{{language}} · pangunahin",
    languages: { en: "Ingles", fil: "Filipino" },
    complete: "Kumpleto",
    missing_one: "{{count}} string na susuriin",
    missing_other: "{{count}} string na susuriin",
    emptyTitle: "Wala pang isasalin",
    emptyBody: "Lalabas dito ang mga mensahe, reply button, tanong at pagtatanong ng rating kapag naisulat na ninyo ang mga ito.",
    savedWithDraft: "Sine-save ang mga salin kasama ng draft: gamitin ang I-save ang draft o I-publish.",
    translationOf: "Salin sa {{language}} ng: {{text}}",
    kinds: { text: "Mensahe", button: "Button", field_label: "Label ng field" },
    fallback: "Ipinapakita ang tekstong Ingles",
    fallbackBuiltIn: "Ipinapakita ang built-in na wika (“Start over” o “Magsimula ulit”)",
    aiDraft: "Draft ng AI: suriin ito",
    draftWithAi: "I-auto-translate ang mga kulang na string",
    draftNothing: "Walang ida-draft: may salin na ang bawat teksto.",
    drafted_one: "Nagawa na ang mga draft na salin — suriin bago i-publish",
    drafted_other: "Nagawa na ang mga draft na salin — suriin bago i-publish",
    stepTitle: "Path {{path}} · {{id}}",
  },
  runs: {
    cancel: "Kanselahin ang run",
    cancelTitle: "Kakanselahin ang run na ito?",
    cancelBody: "Titigil ang run kung nasaan ito at hindi na mangyayari ang natitira nitong mga hakbang. Hindi sasabihan ang bisita.",
    keepRunning: "Hayaang tumakbo",
    cancelConfirm: "Kanselahin ang run",
    cancelled: "Nakansela ang run",
    alreadyEnded: "Tapos na ang run na iyon.",
    calledBy: "Sinimulan ng ibang workflow (antas {{depth}}).",
    goalMet: "Naabot ang layunin {{when}}",
    goalReached: "Naabot ang layunin",
    endedReasons: { cancelled_by_staff: "Kinansela ito ng isang miyembro ng team.", timed_out: "Hindi tumawag ang inyong sistema sa takdang oras." },
  },
  overview: {
    engaged: "Nakipag-ugnayan",
    engagedHint: "{{formatted}} ang nag-tap o sumagot",
    goal: "Layunin",
    goalHint: "{{met}} sa {{tracked}} run: {{event}} sa loob ng {{window}}",
    goalNone: "Magtakda ng layunin sa mga setting ng trigger",
  },
  inbox: {
    button: "Magpatakbo ng workflow",
    label: "Magpatakbo ng reusable na workflow",
    loading: "Nilo-load ang mga workflow…",
    empty: "Wala pang live na reusable workflow. Gumawa ng isa sa Workflows.",
    active: "Tumatakbo ngayon",
    stop: "Ihinto ang {{name}}",
    started: "Sinimulan ang {{name}}",
    stopped: "Itinigil ang {{name}}",
    refused: {
      not_live: "Hindi live ang workflow na iyon.",
      run_active: "May customer-facing na workflow nang tumatakbo sa usapang ito.",
      person_has_conversation: "May taong humahawak sa usapang ito. Ibalik muna ito.",
      switched_off: "Nakapatay ang mga workflow para sa workspace na ito.",
    },
  },
  templates: {
    open: "Mga template",
    loadFailed: "Hindi namin ma-load ang mga template.",
    requirements: {
      setupTitle: "Pagkatapos ninyo itong likhain",
      title: "Gumagamit ang template na ito ng",
      hint: "Tinuturo nito ang mga ito sa inyong workspace. Maaari ninyong palitan ang mga ito sa builder mamaya.",
      connectorLabel: "Endpoint ng records system (Mula lang sa mga workflow ko)",
      connectorMissing: "May itinatanong ang template na ito sa sarili ninyong system, pero wala pa kayong webhook endpoint na nakatakda sa “Mula lang sa mga workflow ko”.",
      labels: { booking_action: "Booking action", endpoint: "Webhook endpoint", team: "Team", user: "Aabisuhang tao", lead_stage: "Yugto ng lead" },
      missing: {
        booking_action: "Nagpapakita ng booking card ang template na ito, pero wala pa kayong booking action.",
        endpoint: "Nagpapadala ng webhook ang template na ito, pero wala pa kayong webhook endpoint.",
        team: "Kailangan ng team ng template na ito, pero wala pa kayo nito.",
        user: "Kailangan ng template na ito ng aabisuhang tao, pero walang makita.",
        lead_stage: "Naglilipat ng lead ang template na ito, pero wala kayong yugto ng lead.",
      },
      create: { booking_action: "Gumawa ng booking action", endpoint: "Magdagdag ng webhook endpoint", team: "Gumawa ng team", user: "Buksan ang Team", lead_stage: "Buksan ang Leads" },
    },
  },
} as const;
